<script setup lang="ts">
import type { ParsedContent } from '@nuxt/content'
import { registerLicense } from '@syncfusion/ej2-base'
import ContentSearch from '~/components/ui/ContentSearch.vue'

useHead({
  meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1' }],
  link: [{ rel: 'icon', href: '/favicon.ico' }],
  htmlAttrs: { lang: 'en' }
})

useSeoMeta({
  ogImage: '/social-card.png',
  twitterImage: '/social-card.png',
  twitterCard: 'summary_large_image'
})

registerLicense(
  'ORg4AjUWIQA/Gnt2XFhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5Xd0BjWH5cc3NRQWNYWkZ/'
)

const nuxtApp = useNuxtApp()
const loading = ref(false)

nuxtApp.hook('page:start', () => {
  loading.value = true
})
nuxtApp.hook('page:finish', () => {
  loading.value = false
})

const { data: navigation } = await useAsyncData('navigation', () => fetchContentNavigation())
const { data: files } = useLazyFetch<ParsedContent[]>('/api/search.json', {
  default: () => [],
  server: false
})
const links = [
  {
    label: 'Home',
    to: '/',
    icon: 'i-heroicons-cube-transparent'
  },
  {
    label: 'BPSDM Pertahanan',
    to: '/bpsdm-pertahanan',
    icon: 'i-heroicons-shield-check'
  },
  {
    label: 'Personel',
    to: '/personel',
    icon: 'carbon:user-military'
  },
  {
    label: 'Pusdiklat',
    to: '/pusdiklat',
    icon: 'i-heroicons-academic-cap',
    children: [
      {
        label: 'Pusdiklat Tekfunghan',
        to: '/pusdiklat/tekfunghan',
        icon: 'i-heroicons-briefcase',
        image: '/assets/logo-subbadan-tekfunghan.png',
        description: 'Pusdiklat Teknis Fungsional Pertahanan.'
      },
      {
        label: 'Pusdiklat Jemenhan',
        to: '/pusdiklat/jemenhan',
        icon: 'i-heroicons-clipboard-document-list',
        image: '/assets/logo-subbadan-jemenhan.png',
        description: 'Pusdiklat Manajemen Pertahanan.'
      },
      {
        label: 'Pusdiklat Bahasa',
        to: '/pusdiklat/bahasa',
        icon: 'i-heroicons-book-open',
        image: '/assets/logo-subbadan-bahasa.png',
        description: 'Pusat Pendidikan dan Pelatihan Bahasa.'
      },
      {
        label: 'Pusdiklat Bela Negara',
        to: '/pusdiklat/bela-negara',
        icon: 'i-heroicons-shield-check',
        image: '/assets/logo-subbadan-belanegara.png',
        description: 'Pusat Pendidikan dan Pelatihan Bela Negara.'
      }
    ]
  },
  {
    label: 'Diklat',
    to: '/diklat',
    icon: 'i-heroicons-book-open'
  },
  {
    label: 'Berita',
    to: '/berita',
    icon: 'i-heroicons-newspaper'
  },
  {
    label: 'Kontak',
    to: '/kontak',
    icon: 'heroicons:chat-bubble-oval-left-ellipsis'
  }
]
</script>

<template>
  <AppHeader />

  <UMain>
    <NuxtLoadingIndicator
      color="#ff8904"
      :height="2"
    />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UMain>

  <AppFooter />

  <UModals />

  <ClientOnly>
    <ContentSearch
      :files="files"
      :navigation="navigation"
      :links="links"
    />
  </ClientOnly>

  <UNotifications />
</template>
